// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","193":"software","443":"about"}[chunkId] + "." + {"177":"4d5f5b0f","193":"4f034e44","443":"cdc1d40a"}[chunkId] + ".css";
};